module.exports = __webpack_public_path__ + "public/adminIcons/defaultAdmin.svg?1105f90c";


//////////////////
// WEBPACK FOOTER
// ./public/adminIcons/defaultAdmin.svg
// module id = 97
// module chunks = 8